export default function LoadingComponent(){
    return(
        <div className="loading">
            <h1 id="head">Loading</h1>
        </div>
    )
}